import styles from './VerificationCard.module.scss';

const VerificationCard = ({ children }) => <div className={styles.root}>{children}</div>;

export default VerificationCard;
